import { useState } from "react";
import { Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(email, password);
    } catch (ex) {
      setErr(errMsg(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F5F0E9] flex flex-col">
      <div className="max-w-[420px] w-full mx-auto px-6 flex-1 flex flex-col">
        <div className="pt-16 pb-10 fade-up">
          <div className="flex items-center gap-2 text-[#C8553D]">
            <span className="w-10 h-10 rounded-xl bg-[#C8553D] text-white flex items-center justify-center font-extrabold text-lg">%</span>
            <span className="text-2xl font-extrabold tracking-tight" data-testid="login-brand">HisseDari</span>
          </div>
          <p className="text-sm text-[#718096] mt-2">Co-ownership, documented.</p>
        </div>
        <div className="fade-up" style={{ animationDelay: "80ms" }}>
          <h1 className="text-3xl font-bold tracking-tight">Welcome back</h1>
          <p className="text-[#718096] mt-1.5">Sign in to see everything you co-own.</p>
        </div>
        <form onSubmit={submit} className="mt-8 space-y-4 fade-up" style={{ animationDelay: "140ms" }}>
          <label className="block">
            <span className="block text-sm font-semibold mb-1.5">Email</span>
            <input data-testid="login-email-input" className="hd-input" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
          </label>
          <label className="block">
            <span className="block text-sm font-semibold mb-1.5">Password</span>
            <input data-testid="login-password-input" className="hd-input" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
          </label>
          {err && <div data-testid="login-error" className="text-sm text-red-700 bg-red-50 rounded-xl px-3 py-2.5">{err}</div>}
          <button data-testid="login-submit-button" className="hd-btn-primary w-full mt-2" disabled={busy}>
            {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <div className="mt-auto pb-10 pt-10 flex items-center gap-2 text-xs text-[#718096]">
          <Lock size={14} /> Private beta · access by invitation only
        </div>
      </div>
    </div>
  );
}
